export const TOGGLE_NAVIGATION_REQUEST = 'TOGGLE_NAVIGATION_REQUEST'
